import {
  AddEmailsParams,
  AddRequirementsParams,
  FileUploadParams,
  SaveReviewedRequirementsParams,
} from "../utils/types";
import { StepFourState } from "../../../store/types";
import { axiosInstance } from "../../../services";

export const apiService = {
  //-----------------SAVE ASSESSMENT-----------------------//
  //step 1
  addRequirements: async (data: AddRequirementsParams) => {
    try {
      const response = await axiosInstance.post(
        "/assessment/add-requirements",
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },

  //step 2
  saveReviewedRequirements: async (data: SaveReviewedRequirementsParams) => {
    try {
      const response = await axiosInstance.post(
        "/assessment/add-customized-skills-distribution",
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },

  //step 3
  //get questions

  //step 4
  //only works for time period mode.
  addTiming: async (timing: StepFourState) => {
    try {
      const response = await axiosInstance.post(
        "/assessment/add-timings",
        timing
      );
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },
  //duration mode
  //enable/disable proctoring
  //start questions like phone number, github etc.

  //step 5
  addEmails: async (data: AddEmailsParams) => {
    try {
      const response = await axiosInstance.post("/assessment/add-emails", data);
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },

  //Get assessment by ID
  getAssessmentById: async (id: string) => {
    try {
      const response = await axiosInstance.get("/assessment", {
        params: { id },
      });
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },

  //GET SKILL DISTRIBUTION
  getTopics: async (assessmentId: string) => {
    try {
      const response = await axiosInstance.post(
        "/assessment/get-assessment-skills-distribution",
        { assessmentId }
      );
      return {
        topics: response.data.response,
        totalQuestions: response.data.totalQuestions,
      };
    } catch (error) {
      console.error("Error fetching topics:", error);
      throw error;
    }
  },

  //CSV UPLOAD
  uploadCSV: async (data: FileUploadParams) => {
    try {
      const response = await axiosInstance.post("/assessment/add-emails", data);
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },

  //GET CANDIDATES
  getCandidates: async (data: any) => {
    try {
      const response = await axiosInstance.post(
        "/assessment/assessment-user-list",
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error adding requirements: ", error);
      throw error;
    }
  },
};
